export const colors = {
  primitive: {
    black: '#000000',
    white: '#FFFFFF',
    thatch: {
      50: '#FCFBFD',
      100: '#F9F4FF',
      200: '#F1E2FF',
      300: '#DBB6FF',
      400: '#BE79FF',
      500: '#9C3BFF',
      600: '#7A26CF',
      700: '#5C1C9B',
      800: '#4B1377',
    },
    slate: {
      50: '#F1F5F9',
      100: '#E2E8F0',
      200: '#CBD5E1',
      300: '#94A3B8',
      400: '#64748B',
      500: '#475569',
      600: '#334155',
      700: '#1E293B',
    },
    gray: {
      50: '#FAFAFA',
      100: '#F5F5F5',
      200: '#E5E5E5',
      300: '#CFCFCF',
      400: '#919191',
      500: '#6E6E6E',
      600: '#525252',
      700: '#424242',
      800: '#303030',
    },
    red: {
      50: '#FEEEF0',
      100: '#FBDEDE',
      200: '#FFC0C0',
      300: '#F98F8F',
      400: '#EC3939',
      500: '#B61717',
      600: '#7F1D1D',
      700: '#450A0A',
    },
    orange: {
      50: '#FFF7ED',
      100: '#FFEDD5',
      200: '#FED7AA',
      300: '#FFC879',
      400: '#B27400',
      500: '#6F4E00',
      600: '#513800',
      700: '#251A00',
    },
    yellow: {
      50: '#FEFCE8',
      100: '#FEF9C3',
      200: '#FFEF9D',
      300: '#FFE655',
      400: '#BFAE11',
      500: '#4F4700',
      600: '#332E00',
      700: '#1F1C00',
    },
    green: {
      50: '#CDFEE1',
      100: '#B4FED2',
      200: '#92FEC2',
      300: '#47CA67',
      400: '#29845A',
      500: '#0C5132',
      600: '#083D25',
      700: '#092A1B',
    },
    blue: {
      50: '#EFF6FF',
      100: '#E0F0FF',
      200: '#CAE6FF',
      300: '#A8D8FF',
      400: '#0094D5',
      500: '#014971',
      600: '#003A5A',
      700: '#002133',
    },
    violet: {
      50: '#F8F7FF',
      100: '#F2F0FF',
      200: '#E6E2FF',
      300: '#CCC0FF',
      400: '#8051FF',
      500: '#5700D1',
      600: '#4C1D95',
      700: '#2E1065',
    },
  },
}
